export const SET_AUTODIAG = 'SET_AUTODIAG';

export const setAutodiag = (value) => ({
  type: SET_AUTODIAG,
  payload: value,
});
